import { ReactFlowInstance, Node } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    let deleteNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditScraperNode.id)) {
            newNodes.push(node);
        } else {
            deleteNodes.push(node);
            // reactFlowInstance.deleteElements(node.id);
        }
    }

    let edges = context.edges;
    let removeEdges = [];
    let newEdges = [];
    for (const edge of edges) {
        if (edge.id.includes(context.activeEditScraperNode.id)) {
            removeEdges.push(edge);
            // reactFlowInstance.deleteElements(edge.id);
        } else {
            newEdges.push(edge);
        }
    }
    // reactFlowInstance.setEdges(newEdges);
    // reactFlowInstance.setNodes(newNodes);

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode = context.activeEditScraperNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes = reactFlowInstance.getNodes();
    let newNodes = [];
    let activeIds = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
   ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}



export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    properties: {
        'data_input': {
            title: 'Data Input',
            type: 'string',
            description : 'Store to load the data from',
            default: 'default'
        },
        'data_input_custom_key': {
            title: 'Custom Data Key',
            type: 'string',
            description: 'If the data is stored in an array or data model with custom key, enter the key here'
        },
        'user_agent': {
            title: 'User Agent',
            type: 'string',
            description: 'User agent for the browser loaded using this scraper node. Leave blank for system default',
            default: ''
        },
        character_count: {
            title: 'Character Count',
            type: 'number',
            description: 'Character Count of character count, 0 will include all characters',
            default: 0
        },
        strip_tags: {
            title: 'Strip Tags',
            type: 'boolean',
            description: 'Stripe HTML tags from scraper response, i.e. a,i,section',
            default: false
        },
        strip_tags_exclude: {
            title: 'Strip Tags Exclude',
            type: 'string',
            description: 'Strip Tags Exclude from scraper response (Comma separated)',
            default: ''
        },
        body_only: {
            title: 'Body Only',
            type: 'boolean',
            description: 'Process main page body and ignore page headers and footers',
            default: false
        },
        'data_management': {
            title: 'Data Store',
            type: 'string',
            description : 'Store the node response in one of 10 slots. Only the default is processed by the workflow.',
            default: 'default'
        }
    },
}

export const nodeDescription: string = "This node is used to scrape data from a web page.\n" +
    "This node is used to scrape data from a single web page. The returned HTML can be stripped of all tags or all with an exclusion list.\n" +
    "The character count can also be set as well as processing just the main body tag contents or the full html tag contents.\n" +
    "  ";